package br.com.heyagenda.domain.billing

import br.com.heyagenda.domain.model.BillingCycle

actual object PlatformBillingManager {
    actual fun initialize(userId: String?) {
        // In-app purchases via RevenueCat are handled natively on mobile
    }

    actual suspend fun purchase(cycle: BillingCycle): Result<Boolean> {
        return Result.success(true)
    }

    actual suspend fun restorePurchases(): Result<Boolean> {
        return Result.success(false)
    }

    actual suspend fun presentPaywall(): Result<Boolean> {
        return Result.success(true)
    }

    actual fun isProActive(): Boolean = false

    actual fun getExpirationDateMillis(): Long? = null
}
